import React from 'react';

/**
 * Opt-in seam for controls rendered beside a section heading.
 *
 * The companion to `FieldDraftContext`, one level up. That one substitutes what
 * a single control shows; this one lets an overlay put an action on the section
 * that owns a group of them — "accept the eleven drafts in Access Control"
 * without also taking the sixty elsewhere on the questionnaire.
 *
 * It has to live in the engine rather than in the overlay because the engine is
 * what knows the section tree. `Element` walks the schema; the overlay only
 * ever sees one field at a time.
 *
 * With no adapter installed — every form today — `Section` renders exactly what
 * it rendered before: the decorator is not called, and no node is added.
 */
export type SectionDecorator = (args: {
  readonly title?: string;
  /**
   * Every field the section contains, including the ones nested in its
   * subsections — the whole subtree the heading is a heading for.
   */
  readonly fieldIds: readonly string[];
}) => React.ReactNode;

const SectionDraftContext = React.createContext<SectionDecorator | null>(null);

export const SectionDraftProvider = SectionDraftContext.Provider;

export const useSectionDecorator = (): SectionDecorator | null =>
  React.useContext(SectionDraftContext);
